//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IKey} from '../../../../types/key';
import { MatTooltip } from '@angular/material/tooltip';

export interface IExportKeyDialogResult {
  exportPublic: boolean;
  exportPrivate: boolean;
  encrypt: boolean;
  password: string;
}

@Component({
    selector: 'app-export-key-dialog',
    templateUrl: './export-key-dialog.component.html',
    styleUrls: ['./export-key-dialog.component.scss'],
    standalone: false
})
export class ExportKeyDialogComponent implements OnInit {
  @ViewChild('tooltipNew') tooltipNew: MatTooltip;
  @ViewChild('tooltipConfirm') tooltipConfirm: MatTooltip;
  exportPublic = true;
  exportPrivate = false;
  encrypt = true;
  password = '';
  confirm = '';
  capsOnNew: boolean = false;
  capsOnConfirm: boolean = false;
  passwordInputIsFocused: boolean;
  passwordConfirmInputIsFocused: boolean;

  constructor(private readonly dialogRef: MatDialogRef<ExportKeyDialogComponent, IExportKeyDialogResult>,
              @Inject(MAT_DIALOG_DATA) public key: IKey) { }

  ngOnInit(): void {
  }

  onClickOK() {
    const results: IExportKeyDialogResult = {
      exportPrivate: this.exportPrivate,
      exportPublic: this.exportPublic,
      password: this.password,
      encrypt: this.encrypt,
    }
    this.dialogRef.close(results);
  }

  onClickCancel() {
    this.dialogRef.close();
  }

  get disableOKButton(): boolean {
    if (!this.exportPrivate && this.exportPublic) {
      return false;
    } else if (this.exportPrivate && this.key.hasProtectedKey) {
      return false;
    } else if (this.exportPrivate && !this.encrypt) {
      return false;
    } else if (this.exportPrivate && this.encrypt && this.password.length > 0 && this.password === this.confirm) {
      return false;
    }
    return true;
  }

  onCapsLockNewChanged(event: boolean) {
    this.capsOnNew = event && this.passwordInputIsFocused;
  }

  onCapsLockConfirmChanged(event: boolean) {
    this.capsOnConfirm = event && this.passwordConfirmInputIsFocused;
  }

  passwordFocus(id: string) {
    this.passwordInputIsFocused = false;
    this.passwordConfirmInputIsFocused = false;
    switch (id) {
      case "newPassInput":
        this.passwordInputIsFocused = true;
        break;
      case "confirmPassInput":
        this.passwordConfirmInputIsFocused = true;
        break;
    }
  }

  passwordBlur() {
    this.passwordInputIsFocused = false;
    this.passwordConfirmInputIsFocused = false;
  }
}
